import { FC, Key } from "react";
import { isAccordion } from "types/CMS/Unum/accordion";
import { isColumnCardGroup } from "types/CMS/Unum/columnCardGroup";
import { isFeature } from "types/CMS/Unum/feature";
import { section } from "types/CMS/Unum/GeneralPage/generalSection";
import { isInfoCardGroup } from "types/CMS/Unum/InfoCardGroup";
import EmployerInfoCardsSection from "../GeneralComponent/EmployerInfoCardsSection/EmployerInfoCardsSection";
import EmployerFeatureSection from "../GeneralComponent/EmployerFeatureSection/EmployerFeatureSection";
import EmployerFeatureAccordion from "../GeneralComponent/EmployerFeatureAccordion/EmployerFeatureAccordion";
import EmployerColumnCardSection from "../GeneralComponent/EmployerColumnCardSection/EmployerColumnCardSection";

const Section: FC<{ section: section; key?: Key }> = ({ section, key }) => {
  switch (true) {
    case isInfoCardGroup(section):
      return <EmployerInfoCardsSection section={section} key={key} />;
    case isColumnCardGroup(section):
      return <EmployerColumnCardSection section={section} key={key} />;
    case isFeature(section):
      return <EmployerFeatureSection section={section} key={key} />;
    case isAccordion(section):
      return <EmployerFeatureAccordion section={section} key={key} />;
    default:
      return <></>;
  }
};
export default Section;
